import { technicalId, technicalIdLabel, technicalIdValue } from './admin.css'
import { compactTechnicalId } from './technical-id'

export function TechnicalId({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null

  return (
    <span className={technicalId} title={value}>
      <span className={technicalIdLabel}>{label}</span>
      <span className={technicalIdValue}>{compactTechnicalId(value)}</span>
    </span>
  )
}
